import {useEffect, useRef, useState} from "react";
import {FileUploader} from "react-drag-drop-files";

const noop = () => {};

export default function DragDropInput({
                                          fileTypes, defaultValue, name, onChangeCallback = noop, onDeleteCallback= noop, ...other
                                      }) {
    const [file, setFile] = useState(defaultValue);
    const buttonRef = useRef();
    const wrapperRef = useRef();
    const fileInputRef = useRef();




    useEffect(() => {
        wrapperRef.current?.addEventListener("click", captureClick, true);
    }, []);

    useEffect(() => {
        setFile(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        if(fileInputRef?.current && file) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            fileInputRef.current.files = dataTransfer.files;
        }
    }, [file]);

    const handleChange = (file) => {
        console.log("FILE WAS SET")
        setFile(file);
        onChangeCallback(file, name);
    };

    const captureClick = (event) => {
        if (event.target === buttonRef.current) {
            event.stopPropagation();
            setFile(null);
            onDeleteCallback(name);
        }
    }

    return (
        <div ref={wrapperRef} style={other.style}>
            <FileUploader handleChange={handleChange} name={""} types={fileTypes} fileOrFiles={file}
                          classes={`dropify-wrapper ${file ? "has-preview" : ""}`} required={other.required}
                          children={
                        <>
                            {!file && <div className="dropify-message">
                                <span className="file-icon"/>
                                <p>Arrastre y suelte un archivo o haga click</p>
                                <p className="dropify-error">Ooops, algo ha ido mal.</p>
                            </div>}
                                              <div className="dropify-loader"></div>
                            <div className="dropify-errors-container">
                                <ul></ul>
                            </div>
                            <button ref={buttonRef} type="button" className="dropify-clear">Eliminar</button>
                            <div className="dropify-preview">
                                    <span className="dropify-render">
                                        <FilePreview file={file} fileTypes={fileTypes}/>
                                    </span>
                                <div className="dropify-infos">
                                    <div className="dropify-infos-inner"><p className="dropify-filename"><span
                                        className="dropify-filename-inner"></span></p><p
                                        className="dropify-infos-message">Arrastre y suelte o haga click para reemplazar</p>
                                    </div>
                                </div>
                            </div>
                        </>}/>
            <input ref={fileInputRef} name={name} type={"file"} style={{display: "none"}}/>

        </div>
    );
}

function FilePreview({file, fileTypes}) {
    const imageTypes = ['JPG', 'JPEG', 'PNG'];
    const videoTypes = ['MP4', 'WEBM']
    const url = file ? window.URL.createObjectURL(file) : ""
    if (fileTypes?.filter(value => imageTypes.includes(value)).length > 0) {
        return <img src={url}/>
    } else if (fileTypes?.filter(value => videoTypes.includes(value)).length > 0) {
        return <div key={url} style={{height: "100%"}}>
            {url && <video width="100%" height="100%" controls style={{position: "relative", zIndex: "10"}}>
                <source src={url} type={file?.type}/>
            </video>}
        </div>
    } else {
        return <>
            <i className="dropify-font-file"></i>
            <span className="dropify-extension">{file?.name.split(".").slice(-1)}</span>
            <span className="dropify-filename">{file?.name}</span>
        </>
    }
}